import {DayFormats} from "../utils/date-util";
import {Dayjs} from "../utils/dayjs";

export function formatRevisionNumber(revisionNumber: number | null, appliedAt: Dayjs | null) {
    return revisionNumber
        ? `R${revisionNumber} (${appliedAt!.format(DayFormats.datetimeMinute)})`
        : "(未公開)";
}
